module.exports = __webpack_public_path__ + "media/images/vp/slider.index.02-9fdbee4bc74f0ba035dc0bc9847c3575.jpg";